import { colors } from '@constants/colors';

export const useStyles = () => ({
  root: {
    width: 283,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.5,
    padding: 2,
  },
  text: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 1.5,
    color: colors.white,
    padding: 0,
  },
  icon: {
    fontSize: 64,
  },
  button: {
    width: '100%',
    fontSize: 14,
  },
});
